import { ApiClient, ApiClientConfig } from "../api-client";
import { ApiClientError } from "../errors";
import schemaValidators from "./schema-validators";
import { parse } from "yaml";

export default class DownloadClient extends ApiClient<typeof schemaValidators> {
	constructor(config: ApiClientConfig) {
		super(config, schemaValidators);
	}

	getLockdownDownloadUrl = async <Os extends "mac" | "mac-arm" | "win">(
		os: Os,
		type?: Os extends "win" ? "exe" | "msi" : undefined,
	) => {
		try {
			const response = await fetch(
				`${this.config.lockdown.origin}/${this.config.lockdown.channel}${os.startsWith("mac") ? "-mac" : ""}.yml`,
			);
			if (response.ok) {
				const text: unknown = await response.text();
				if (typeof text === "string") {
					const appMeta: unknown = parse(text);
					if (this.schemaValidators.lockdownDownloadPath.validate(appMeta)) {
						let filename = appMeta.path;
						if (os === "mac-arm") {
							filename = appMeta.files.find(({ url }) => url.endsWith("arm64.dmg"))?.url ?? filename;
						} else if (os === "mac") {
							filename =
								appMeta.files.find(({ url }) => !url.endsWith("arm64.dmg") && url.endsWith(".dmg"))?.url ?? filename;
						} else {
							filename = appMeta.files.find(({ url }) => url.endsWith(`.${type ?? "exe"}`))?.url ?? filename;
						}
						return `${this.config.lockdown.origin}/${encodeURIComponent(filename)}`;
					}
				}
			}
		} catch (error) {
			if (error instanceof Error) {
				throw new ApiClientError(error);
			}
		}
		throw new ApiClientError();
	};

	requestProctoringSessionRecordingDownload = async (
		sessionId: string | number,
		userEnteredEmail: string,
		userEnteredName: string,
	) => {
		try {
			const response = await super.fetch(
				`${this.config.verityOrigin}/api/verity/quiz/recording/download-request/${sessionId}/${userEnteredEmail}/${userEnteredName}`,
				{
					method: "POST",
					credentials: "include",
				},
			);
			if (response.ok) {
				const details: unknown = await response.json();
				if (this.schemaValidators.requestProctoringSessionDownloadResponse.validate(details)) {
					return details;
				}
				throw new Error(`Invalid shape of response: ${JSON.stringify(details)}`);
			}
			throw new Error(`Invalid response, ${response.status}`);
		} catch (error) {
			if (error instanceof Error) {
				throw new ApiClientError(error);
			}
		}
		throw new ApiClientError();
	};
}
